import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "layout-config" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = ["for"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_RadioButton = _resolveComponent("RadioButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      id: "layout-config-button",
      class: "layout-config-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onConfigButtonClick($event)))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: _normalizeClass(["layout-config", { 'layout-config-active': _ctx.configActive }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onConfigClick && _ctx.onConfigClick(...args)))
    }, [
      (_ctx.loading || _ctx.IamLoading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t("workspaceLayout.menuType")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTypes, (type, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "p-field-radiobutton"
        }, [
          _createVNode(_component_RadioButton, {
            name: "menuMode",
            value: index,
            "model-value": _ctx.settings[0],
            "onUpdate:modelValue": ($event: any) => (_ctx.setSetting(0, index)),
            id: `mode${index}`
          }, null, 8, ["value", "model-value", "onUpdate:modelValue", "id"]),
          _createElementVNode("label", {
            for: `mode${index}`
          }, _toDisplayString(_ctx.$t(`workspaceLayout.${type}`)), 9, _hoisted_4)
        ]))
      }), 128)),
      _hoisted_5,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t("workspaceLayout.colorScheme")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorSchemes, (color, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "p-field-radiobutton"
        }, [
          _createVNode(_component_RadioButton, {
            name: "colorScheme",
            value: index,
            "model-value": _ctx.settings[1],
            id: `theme${index}`,
            onChange: ($event: any) => (_ctx.changeColorScheme(index))
          }, null, 8, ["value", "model-value", "id", "onChange"]),
          _createElementVNode("label", {
            for: `theme${index}`
          }, _toDisplayString(_ctx.$t(`workspaceLayout.${color}`)), 9, _hoisted_6)
        ]))
      }), 128)),
      _hoisted_7,
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}